module.exports = __webpack_public_path__ + "static/media/fines_manager.d5e95c14.png";